import { IRule } from '@/classes/rules/IRule';

/**
 * This class express the state of a "step" of the scenario editor.
 */
export class StepConfig {

  public index: number; // Index of the step in the step list. Can change when step are displayed or not
  public readonly name: string; // Name of the step, displayed in the stepper not translated.
  public readonly key: string; // identifier of the step. Used for translations among other things
  public readonly goTo: string; // local url of the step

  public readonly icon: string; // icon of the step
  public available: boolean; // the step can be displayed
  public hasBeenVisited: boolean; // the step has been visited at least once during current scenario edition
  public mustBeControlled: boolean; // the step fields must be controlled when the user lands on it.
  public hasErrors: boolean; // the step has errors in its fields
  public readonly fields: string[]; // list of the scenario fields that must be controlled to say if the step has errors or not.
  public readonly excludedFields: string[];

  public rulesByPath: Map<string, IRule>; // map of rules in order to store them instead of go searching for them each time.

  constructor(options?: any) {
    options = options || {};

    this.index = options.index || 0;
    this.name = options.name || '';
    this.key = options.key || '';
    this.goTo = options.goTo || '';

    this.icon = options.icon || '';

    this.available = !!options.available;
    this.hasBeenVisited = !!options.hasBeenVisited;
    this.mustBeControlled = !!options.mustBeControlled;
    this.hasErrors = !!options.hasErrors;
    this.fields = options.fields || [];
    this.excludedFields = options.excludedFields || [];

    this.rulesByPath = options.rules || new Map();
  }
}
